import React from 'react';
import { feedbackV2 } from '@ecosystem/newron-design-system';
import { NO_DATA_WARNING } from '../../common/constants/warningMessages';

const { Alert } = feedbackV2;

export interface EmptyDataWarningProps {
  className?: string;
  message?: string;
  style?: { [k: string]: string | number };
}

export const EmptyDataWarning: React.FC<EmptyDataWarningProps> = ({ className, message = NO_DATA_WARNING, style }) => {
  return (
    <div className={`h-full pt-15 ${className}`} style={style}>
      <Alert title={message} type="warn" />
    </div>
  );
};
